import { useFreshchatWidget } from './hooks/useFreshchatWidget'
import { Link } from './Link'
import { Section } from './Section'
import { sidebarData } from './sidebarData'

export function Sidebar() {
  const { isWidgetOpen } = useFreshchatWidget()

  return (
    <aside className="bg-white p-4 border-round-sm shadow-1">
      {sidebarData.map(section => (
        <Section key={section.title} title={section.title} variant={section.variant || 'default'}>
          {section.links.map(link => (
            <Link
              key={`${link.label}-${link.url}`}
              {...link}
              isActive={link.isWidget ? isWidgetOpen : undefined}
            />
          ))}
        </Section>
      ))}
    </aside>
  )
}
